// Internal Imports
import {
  getCategories,
  getProducts,
  getProductFamilies,
  updateProductService,
} from "./productServices";
import parseRowData from "./productMethods";

export const getInitData = view => async dispatch => {
  try {
    // Fetch Column Data
    const products = getProducts(view.metaData);
    const categories = getCategories();
    const productFamilies = getProductFamilies();

    Promise.all([view, products, categories, productFamilies])
      .then(response => {
        dispatch({
          type: "REACTION_PRODUCTS_INIT_DATA",
          payload: response,
        });
      })
      .catch(error => {
        console.debug("productActions =>", error);
        throw error;
      });
    return null;
  } catch (error) {
    throw error;
  }
};

export const updateProductData = (obj, flag) => dispatch =>
  new Promise((resolve, reject) => {
    updateProductService(obj)
      .then(response => {
        const data = parseRowData(response, flag);
        dispatch({
          type: "UPDATE_ROW_DATA",
          payload: data,
        });
        resolve("success");
      })
      .catch(error => {
        console.debug("productActions =>", error);
        reject(error);
      });
  });

export const togglePopUp = flag => dispatch => {
  dispatch({
    type: "TOGGLE_POP_UP",
    payload: flag,
  });
};
